// extracted by mini-css-extract-plugin
export default {"explorerShortlistsToggleBtn":"drxjzWTYjoNeifVPJtsJ","explorerShortlistsToggleBtnDisabled":"foMXQW3KyFEWp_waWuST"};